// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ANONYMOUS_USERNAME = "anonym";
export const LOGIN_TITLE = "Prihl\u00e1senie";
export const SIGNUP_TITLE = "Registr\u00e1cia";
